
import { z } from 'zod';

export const ChangeOrderSchema = z.object({
    id: z.number().optional(),
    projectId: z.number().optional(),
    coNumber: z.string().min(1, 'CO Number is required'),
    title: z.string().min(3, 'Title must be at least 3 characters'),
    amount: z.number().min(0, 'Amount cannot be negative. Use a separate credit item if needed.'),
    status: z.enum(['Draft', 'Submitted', 'Negotiating', 'Approved', 'Rejected', 'Void']),
    date: z.string().refine((val) => !isNaN(Date.parse(val)), {
        message: "Invalid date format",
    }),
    description: z.string().min(10, 'Please provide a detailed scope description (min 10 chars).'),
    communicationLog: z.string().optional(),
    accountabilitySummary: z.string().optional(),
});

export const ProjectSchema = z.object({
    title: z.string().min(3, 'Project title required'),
    client: z.string().min(2, 'Client name required'),
    contractAmount: z.number().positive('Contract amount must be positive'),
    startDate: z.string(),
    endDate: z.string(),
    status: z.enum(['Bidding', 'Pre-Con', 'Active', 'On Hold', 'Completed', 'Closed']),
    location: z.string().optional(),
    siteAddress: z.string().optional(),
}).refine((data) => {
    const start = new Date(data.startDate);
    const end = new Date(data.endDate);
    return end >= start;
}, {
    message: "End date must be after start date",
    path: ["endDate"],
});

export type ChangeOrderForm = z.infer<typeof ChangeOrderSchema>;
export type ProjectForm = z.infer<typeof ProjectSchema>;
